module.exports = __webpack_public_path__ + "static/media/icon-design.66f9c61f.svg";